import React from 'react';
import get from "lodash/get";
import { connect } from 'react-redux';

const ErrorMessageComponent = ({errors, inputField}) => {
  if(errors[inputField] && errors[inputField].length > 0) {
    return (
      <div className="error-message">{get(errors, [inputField, 0], '')}</div>
    )
  } else {
    return <div></div>;
  }
}

const mapStateToProps = ({formLoginReducers}) => {
  return {
    errors: formLoginReducers.errors
  }
}

export default connect(mapStateToProps)(ErrorMessageComponent);


// WEBPACK FOOTER //
// ./app/javascript/pages/page/form_login_modal/get_error_message.js